<template>
  <div>
    <a-drawer
      placement="right"
      :width="360"
      @close="onClose"
      :visible="visible"
    >
      <div class="row justify-content-center">
        <div class="col-xl-12">
          <a-spin :spinning="loading">
            <div>
              <p class="font-weight-bold">Activities</p>
              <ul class="list-group list-group-flush" v-if="data.length">
                <li
                  v-for="item in data"
                  :key="item.id"
                  class="list-group-item px-0"
                >
                  <activity :item="item" :user="user.user"/>
                </li>
              </ul>
              <div v-else class="py-5">
                <no-data text="No Activities" />
              </div>
            </div>
            <div class="text-right mt-3">
              <a-pagination
                  size="small"
                  :total="meta.total"
                  v-model="current"
                  @change="onChange"
                >
              </a-pagination>
            </div>
          </a-spin>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Activity from './partials/activity'

import NoData from '@/components/layout/NoData/index'

export default {
  components: {
    Activity,
    NoData,
  },
  mounted: function () {
    this.$eventBus.$on('openActivityLogDrawer', this.showDrawer)
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
    }
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    showDrawer() {
      this.visible = true
      this.getActivities()
    },
    onClose() {
      this.visible = false
    },
    getActivities: function() {
      this.loading = true
      this.$http.get('/api/activity_log/all', {
        params: {
          school_id: 0,
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    onChange(current) {
      this.current = current
      this.getActivities()
    },
  },
}
</script>
